import styles from "./style.module.scss";

export default function LaneTrendItemSkeleton() {
  return (
    <li className={`${styles.rateTrendLanesBody} animate-pulse`}>
      <div>
        <div className={styles.rateTrendLanesRow}>
          <span className="h-4 w-24 bg-gray-300 rounded" />
          <span className="h-4 w-6 bg-gray-300 rounded" />
          <span className="h-4 w-24 bg-gray-300 rounded" />
        </div>
        <span className="h-4 w-12 bg-gray-300 rounded ml-auto" />
      </div>

      <div>
        <span className="h-4 w-20 bg-gray-300 rounded" />
        <span className="h-4 w-16 bg-gray-300 rounded ml-auto" />
      </div>

      <div>
        <span className="h-4 w-16 bg-gray-300 rounded" />
        <span className="h-4 w-12 bg-gray-300 rounded ml-auto" />
      </div>
    </li>
  );
}
